<style lang="scss">
.client-form {
  margin-bottom: 100px;
}
</style>
<template>
  <div style="max-width: 950px" class="mx-auto">
    <v-card fluid class="client-form">
      <v-card-title>
        Clientes
        <v-spacer></v-spacer>
        <v-btn @click="indexClients(options)" icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row class="mt-5">
          <v-col cols="12" sm="6" md="5">
            <v-text-field
              @keyup.enter="handleFilter($event.target.value)"
              prepend-inner-icon="mdi-magnify"
              label="Buscar cliente"
              v-model="filter"
              clearable
              @click:clear="handleFilter('')"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col class="d-none d-sm-flex align-top justify-end">
            <v-btn color="red" dark @click="handleClickAdd()">
              <v-icon left>mdi-plus</v-icon>Cadastrar
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <AdvancedFilterChips
              :headers="[
                {
                  id: 'debito',
                  label: 'Débito mínimo'
                },
                {
                  id: 'ultimo_pagamento',
                  label: 'Último pagamento (dias)'
                }
              ]"
              :filters="$route.query"
              :defaults="[
                {
                  label: 'Débitos em atraso',
                  filters: {
                    ultimo_pagamento: 45,
                    debito: 0.01
                  }
                }
              ]"
              @clear="updateFilters()"
              @filter="updateFilters"
              @click:filter="handleClickOpenFilter()"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="clients"
        :options.sync="options"
        :server-items-length="totalClients"
        hide-default-footer
        mobile-breakpoint="960"
      >
        <!-- <template v-slot:item.id="{ item }">
          <a @click="handleClickEdit(item)">
            {{ item.id }}
          </a>
        </template> -->
        <template v-slot:item.nome="{ item }">
          <a @click="handleClickEdit(item)">
            {{ item.nome }}
          </a>
        </template>
        <template v-slot:item.limite_credito_disponivel="{ item }">
          <span
            :class="{
              'green--text': item.limite_credito_disponivel > 0,
              'red--text': item.limite_credito_disponivel <= 0
            }"
          >
            {{ formatMoney(item.limite_credito_disponivel) }}
          </span>
        </template>
        <template v-slot:item.limite_credito_utilizado="{ item }">
          <span :class="{ 'red--text': item.limite_credito_utilizado > 0 }">
            {{ formatMoney(item.limite_credito_utilizado) }}
          </span>
        </template>
        <template v-slot:item.last_payment_date="{ item }">
          <span>
            {{ formatDate(item.last_payment_date, "---") }}
          </span>
        </template>
        <template v-slot:item.image="{ item }">
          <div class="my-1">
            <v-avatar color="grey lighten-1" rounded>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
                v-if="!item.image_url"
              >
                <v-icon color="#f1f1f1"> mdi-image-off-outline </v-icon>
              </v-row>
              <v-img
                @click="showImage(item.image_url)"
                v-else
                :src="item.image_url"
                style="cursor: pointer"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="white"
                      size="50"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            @click="handleClickEdit(item)"
            icon
            :disabled="checkExcluding(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click="handleClickDelete(item)"
            icon
            :loading="checkExcluding(item)"
          >
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </template>
        <template v-slot:footer="{ props, on }">
          <v-data-footer
            v-bind="props"
            v-on="on"
            :items-per-page-options="[5, 10, 15, 20]"
          />
        </template>
      </v-data-table>

      <v-btn
        @click="client_form = true"
        fab
        fixed
        right
        color="red"
        dark
        style="bottom: 15px"
        class="d-sm-none"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>

    <v-dialog
      v-model="client_form"
      max-width="700"
      persistent
      :fullscreen="$vuetify.breakpoint.mobile"
      eager
    >
      <client-form
        ref="form"
        @cancel="handleClickCancel()"
        @submitted="handleSubmitForm()"
        :visible="client_form"
      ></client-form>
    </v-dialog>

    <v-dialog v-model="image_dialog" max-width="500" overlay-opacity=".9">
      <v-card dark>
        <!-- <v-card-title>
          <v-spacer></v-spacer>
          <v-btn @click="image_dialog = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title> -->
        <v-img :src="image_src"></v-img>
      </v-card>
    </v-dialog>

    <ClienteFiltroDialogo ref="dialogo_filtro" @submit="handleApplyFilters" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ClientForm from "../components/forms/ClientForm";
import { index } from "@/services/clients";
import MoneyMixin from "@/mixins/MoneyMixin";
import DateTimeMixin from "@/mixins/DateTimeMixin";
import ClienteFiltroDialogo from "../components/clientes/ClienteFiltroDialogo.vue";
import AdvancedFilterChips from "@/components/AdvancedFilterChips.vue";

export default {
  components: { ClientForm, ClienteFiltroDialogo, AdvancedFilterChips },
  mixins: [MoneyMixin, DateTimeMixin],
  name: "clients",
  data: () => ({
    headers: [
      { text: "", value: "image", width: "70" },
      { text: "Nome", value: "nome" },
      { text: "Código", value: "id", width: "100" },
      { text: "Telefone", value: "contato1", sortable: false },
      { text: "Crédito disponível", value: "limite_credito_disponivel" },
      { text: "Débito", value: "limite_credito_utilizado" },
      { text: "Último pagamento", value: "last_payment_date" },
      { text: "", value: "actions", sortable: false, align: "right" }
    ],
    options: {
      itemsPerPage: 10,
      sortBy: ["nome"],
      sortDesc: []
    },
    client_form: false,
    filter: "",
    clients: [],
    totalClients: 0,
    loading: false,
    excluding_id: null,
    image_src: null,
    image_dialog: false
  }),
  methods: {
    handleApplyFilters(filters) {
      this.$refs.dialogo_filtro.close();
      this.$router.replace({
        path: "/clientes",
        query: {
          ...filters,
          filter: this.filter
        }
      });
    },
    handleClickOpenFilter() {
      this.$refs.dialogo_filtro.open(this.$route.query);
    },
    updateFilters(filters = {}) {
      console.log(filters);
      this.$router.replace({
        path: "/clientes",
        query: {
          ...filters,
          filter: this.filter
        }
      });
    },
    handleClickAdd() {
      this.$refs.form.reset();

      this.client_form = true;
    },
    showImage(image) {
      this.image_src = image;
      this.image_dialog = true;
    },
    ...mapActions("clients", [
      "deleteClient",
      "showClient",
      "destroyClient",
      "setFilter"
    ]),
    ...mapMutations("clients", ["setOptions"]),
    handleClickEdit(item) {
      this.$router.push({
        name: "pagina_cliente",
        params: {
          id: item.id
        }
      });
      // this.showClient(item.id);
      // this.client_form = true;
    },
    async handleClickDelete(item) {
      this.$store.dispatch("confirm_dialog/confirm", {
        title: "Confirmação",
        description: "Tem certeza que deseja excluir o cliente?",
        positive_action: async () => {
          this.excluding_id = item.id;
          try {
            await this.destroyClient(item.id);
            this.clients = this.clients.filter(client => client.id !== item.id);
            this.$store.commit("success", "Cliente removido");
          } catch (error) {
            switch (error.response.status) {
              case 400:
                this.$store.commit("error", error.response.data.message);
                break;
              case 500:
                this.$store.commit("error", "500: Falha ao excluir cliente.");
                break;
              default:
                this.$store.commit("error", error);
            }
          } finally {
            this.excluding_id = null;
          }
        }
      });
    },
    handleClickCancel() {
      this.client_form = false;
    },
    handleSubmitForm() {
      this.client_form = false;
      this.indexClients();
    },
    handleFilter(value) {
      this.$router.replace({
        path: "/clientes",
        query: {
          ...this.$route.query,
          filter: value
        }
      });
    },
    checkExcluding(client) {
      return client.id == this.excluding_id;
    },
    async indexClients() {
      this.loading = true;
      try {
        this.clients = [];
        const response = await index(this.options, this.$route.query);
        this.clients = response.data;
        this.totalClients = response.total;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar clientes",
          color: "red"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.filter = this.$route.query.filter ? this.$route.query.filter : "";
        this.indexClients();
      },
      deep: true
    },
    $route(to, from) {
      this.filter = to.query.filter ? to.query.filter : "";
      this.options.page = 1;
      this.indexClients();
    }
  }
};
</script>
